import Vue from 'vue'
import VueI18n from 'vue-i18n'
import zh from './zh'
import en from './en'
import ja from './ja'
import ko from './ko'
import fr from './fr'
import es from './es'
import it from './it'
import de from './de'
import pt from './pt'
import pl from './pl'
import ar from './ar'
import videoModelSeo from './videoModelSeo'

Vue.use(VueI18n)

const messages = {
  zh,
  en,
  ja,
  ko,
  fr,
  es,
  it,
  de,
  pt,
  pl,
  ar
}

// 将视频模型专属长内容挂载到各语言的 SEO 命名空间，避免影响现有图片模型文案。
Object.keys(videoModelSeo).forEach(function (locale) {
  if (!messages[locale].seo) messages[locale].seo = {}
  messages[locale].seo.videoModels = videoModelSeo[locale]
})

const i18n = new VueI18n({
  locale: 'en',
  fallbackLocale: 'en',
  messages
})

export default i18n
